<template>
  <v-dialog v-model="dialog" persistent max-width="100%">
    <v-card>
      <v-toolbar class="headline" color="primary" dark>食事予約一覧（日毎）</v-toolbar>
      <v-card-title class="noPaddingBtm">
        <h2>{{this.viewTime}}</h2>
        <v-spacer></v-spacer>
        <ryou-black-btn :label="'ファイル出力'" :handlerClick="pdfFileDownLoad" :iconCls="'mdi-file-download'"
          :disabled="btnCtrl">
        </ryou-black-btn>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <v-card-text>
            <v-container style="height: 600px;overflow-y: auto;">
              <v-row>
                <v-col cols="4" v-for="(item, index) in mealNames" :key="index" style="padding: 0px;">
                  <ReservationConfirmation :ref="`list${index}`"></ReservationConfirmation>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'" :disabled="btnCtrl">
            </ryou-black-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import ReservationConfirmation from "./ReservationConfirmation";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import fileDownload from "js-file-download";

  export default {
    name: "MealReservationConfirmationDayDialog",
    components: {
      ReservationConfirmation,
      RyouBlackBtn,
    },
    data() {
      return {
        dialog: false,
        btnCtrl: false,
        time: "",
        viewTime: "",
        mealNames: [],
        contentValue: [],
        groupOptionValue: "",
      };
    },
    watch: {
    },
    methods: {
      //クリックを閉じる
      handleCancel() {
        this.close();
      },
      pdfFileDownLoad() {
        let pdfParams = {
          buildGroupId: this.groupOptionValue,
          inputDate: this.time,
          viewTime: this.viewTime
        };

        this.btnCtrl = true;
        this.getRequest("/mealReservationConfirmation/confirmationPDFCreate", pdfParams, this.$store.getters.getUserToken).then((resp) => {
          //ファイルパスは戻り
          if (resp.success) {
            let streamParams = {
              filePath: resp.result,
            };

            //PDFはダウンロード
            this.getStreamRequest('/mealReservationConfirmation/confirmationPDFGet', streamParams, this.$store.getters.getUserToken).then(res => {
                const blob = new Blob([res], { type: 'application/octet-stream;charset=utf-8' });
             // return fileDownload(blob, "食事予約一覧_" + this.getDateTime() + ".pdf");
              return fileDownload(blob, "食事予約一覧_" + this.getDateTime() + ".xlsx");//PDFへの変換が動作しないので、xlsxをダウンロードするように変更
            }).catch(function (error) {
              console.log(error);
            });
          }
          this.btnCtrl = false;
        });
      },
      getDateTime() {
        const year = new Date().getFullYear()
        const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1)
        const date = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
        const hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
        const mm = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
        const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
        const nowTime = year + month + date + hh + mm + ss
        return nowTime
      },
      // パラメータ1:ダイアログ日付、パラメータ2:物件グループID、パラメータ3:日付の食事名
      getInputValue(time, selectOptionValue, mealNames) {

        if (time) {
          this.time = time;

          let weekDay = ["（日）", "（月）", "（火）", "（水）", "（木）", "（金）", "（土）"];

          let timelist = time.split("-");
          this.viewTime =
            timelist[0] + "年"
            + (timelist[1][0] == "0" ? timelist[1][1] : timelist[1]) + "月"
            + (timelist[2][0] == "0" ? timelist[2][1] : timelist[2]) + "日" + weekDay[new Date(time).getDay()];
        }

        if (selectOptionValue) {
          this.groupOptionValue = selectOptionValue;
        }
        if (mealNames) {
          this.mealNames = mealNames;
        }
        if (time && selectOptionValue) {

          let reserveUserParams = {
            buildGroupId: selectOptionValue,
            inputDate: time
          };

          var that = this;
          this.getRequest("/mealReservationConfirmation/mealReserveUserInfoGet", reserveUserParams, this.$store.getters.getUserToken).then(data => {
            // 食事予約者情報一覧取得
            if (data.success) {

              for (let mealIndex = 0; mealIndex < mealNames.length; mealIndex++) {

                for (let resIndex = 0; resIndex < data.result.length; resIndex++) {

                  if (data.result[resIndex][mealNames[mealIndex].meal_class]) {
                    that.contentValue.push(data.result[resIndex][mealNames[mealIndex].meal_class]);
                  }
                }

                that.$refs[`list${mealIndex}`][0].queryListData(that.contentValue, mealIndex, mealNames[mealIndex].meal_name);
                that.contentValue = [];
              }

            }
          });
        }

        this.open();
      },
      close() {
        this.dialog = false;
        this.clearParameters();
        this.$emit("reCalendar");
      },
      open() {
        this.dialog = true;
      },
      // パラメータをクリア
      clearParameters() {
        this.contentValue = [];
      }
    },
  };
</script>

<style scoped>
  .noPaddingBtm {
    padding-bottom: 0px;
  }

  .noPaddingTop {
    padding-top: 0px;
  }
</style>